export default {
    grouping: {
        placeholder: 'Перетащите сюда заголовок (Наименомение столбца)'
    },
    header: {
        actions: 'Действия',
    },
    body: {
        emptyDataSourceMessage: 'Нет записей для отображения',
        addTooltip: 'Добавить',
        deleteTooltip: 'Удалить',
        editTooltip: 'Изменить',
        filterRow: {
            filterTooltip: 'Фильтровать'
        },
        editRow: {
            deleteText: 'Вы уверены что хотите удалить эту строку ?',
            cancelTooltip: 'Отменить',
            saveTooltip: 'Сохранить',
        },
    },
    toolbar: {
        addRemoveColumns: 'Добавить или удалить колонку',
        nRowsSelected: '{0} строк выделено',
        showColumnsTitle: 'Показать столбцы',
        showColumnsAriaLabel: 'Показать столбцы',
        exportTitle: 'Экспортировать',
        exportAriaLabel: 'Экспортировать',
        exportName: 'Экспортировать в CSV',
        searchTooltip: 'Поиск',
        searchPlaceholder: 'Поиск',
    },
    pagination: {
        labelDisplayedRows: '{from}-{to} из {count}',
        labelRowsSelect: 'строк',
        labelRowsPerPage: 'Строк на странице:',
        firstAriaLabel: 'Первая страница',
        firstTooltip: 'Первая страница',
        previousAriaLabel: 'Предыдущая страница',
        previousTooltip: 'Предыдущая страница',
        nextAriaLabel: 'Следующая страница',
        nextTooltip: 'Следующая страница',
        lastAriaLabel: 'Последняя страница',
        lastTooltip: 'Последняя страница',
    }
}